const USER_PILOT_TOUR_SEARCH_KEY = 'tour';

export { USER_PILOT_TOUR_SEARCH_KEY };
